import { mergeMap, merge } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Types, Creators } from '../ducks/result';
import { Api } from '../../api';

// eslint-disable-next-line
export const createResultPlan = action$ =>
  action$.pipe(
    ofType(Types.CREATE_RESULT_PLAN_REQUESTED),
    mergeMap((({ resultData }) => Api.postResultPlan(resultData)
      .then(res => Creators.createResultPlanSuccess(res))
      .catch(err => Creators.createResultPlanError(err))
    )),
  );

export const retrievePlan = action$ =>
    action$.pipe(
      ofType(Types.RETRIEVE_PLAN_REQUESTED),
      mergeMap((({ data }) => Api.postRetrievePlan(data) 
        .then(res => Creators.retrievePlanSuccess(res))
        .catch(err => Creators.retrievePlanError(err))
      )),
    );

export const fetchPlan = action$ => 
  action$.pipe(
    ofType(Types.FETCH_PLAN_REQUESTED),
    mergeMap((({ data }) => Api.postFetchPlan(data)
      .then(res => Creators.fetchPlanSuccess(res))
      .catch(err => Creators.fetchPlanError(err))
    )),
  );


const epicList = [
  createResultPlan,
  retrievePlan,
  fetchPlan,
];

export default epicList;
